<mat-drawer-container class="container-position">

  <mat-drawer #sideNav mode="side" opened="false" position="end" class="drawer" style="Overflow-y:scroll;">

    <div>
      <br />
      <div class="header-class">

        <div class="col-6">
          <h6>Filtres</h6>
        </div>
        <div class="col-6">
          <button color="warn" mat-raised-button (click)="clearFiltre()">
            <mat-icon>cancel</mat-icon> Réinitialiser
          </button>

        </div>
      </div>
    </div>
    <br />
    <div class="data-class" *ngIf="filtreData">
      <!-- site de livraison +site -->
      <br />
      <div class="row margin_tm_20 ">
        <div class="col-sm-12 margin_bm_20">
          <app-autocomplete-with-code [(objet)]="filtreData.societe" name="societe" (objetChange)="onChange($event)"
            libelle="Société" [objets]="societes" [required]="false" >
          </app-autocomplete-with-code>
        </div>
      </div>
      <div class="row ">
        <div class="col-sm-12 margin_bm_20">
          <app-autocomplete-with-code (objetChange)="onChange($event)" libelle="Site" [objets]="sites"
          [(objet)]="filtreData.bcSite" name="Site" [required]="false" (loadData)="loadData($event, siteService, 'sites')">
          </app-autocomplete-with-code>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <app-autocomplete-with-code (objetChange)="onChange($event)" libelle="Site livraison" [objets]="sitesLiv"
            [(objet)]="filtreData.bcSiteLivr" name="bcSiteLivr" [required]="false" (loadData)="loadData($event, siteService, 'sitesLiv')">
          </app-autocomplete-with-code>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <app-custom-select-multiple-option 
            (selected)="onFiltreChange($event, 'Statut')" [InputvaluesList]="listStatus" 
            [InputSelectedValues]="listStatusUpdated" [title]="'Statut'">
          </app-custom-select-multiple-option>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6 margin_bm_20">
          <app-autocomplete-with-num (objetChange)="onChange($event)" libelle="N° de BC: du" [objets]="bcsStart"
          [(objet)]="filtreData.startNBc" name="BC" [required]="false" (loadData)="loadData($event, bcService, 'bcsStart')">
          </app-autocomplete-with-num>
        </div>
        <div class="col-sm-6 margin_bm_20">
          <app-autocomplete-with-num (objetChange)="onChange($event)" libelle="au" [objets]="bcsEnd"
          [(objet)]="filtreData.endNBc" name="BC" [required]="false" (loadData)="loadData($event, bcService, 'bcsEnd')">
          </app-autocomplete-with-num>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <app-custom-select-multiple-option 
            (selected)="onFiltreChange($event, 'TypeBC')" [InputvaluesList]="listTypesBC" 
            [InputSelectedValues]="listTypesBCUpdated" [title]="'Type de commande'">
          </app-custom-select-multiple-option>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>Libellé du BC</mat-label>
            <input [(ngModel)]="filtreData.libelle" matInput (ngModelChange)="onChange($event)" name="libelle"
              style="font-size: small;" [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <app-autocomplete-with-code (objetChange)="onChange($event)" libelle="Catégorie d'achat" [objets]="categories"
            [(objet)]="filtreData.categorie" name="categorie" [required]="false" (loadData)="loadData($event, categorieService, 'categories')">
          </app-autocomplete-with-code>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>N° de BC Amont : du</mat-label>
            <input [(ngModel)]="filtreData.startNBcAmont" matInput (ngModelChange)="onChange($event)" name="NBcAmont"
              style="font-size: small;" [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
        <div class="col-sm-6 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>au</mat-label>
            <input matInput [(ngModel)]="filtreData.endNBcAmont" (ngModelChange)="onChange($event)" name="NBcAmont"
              style="font-size: small;" [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
      </div>
      <!-- date BC -->
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>Date du BC</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate [(ngModel)]="filtreData.startDBc" (ngModelChange)="onChange($event)" name="DBc">
              <input matEndDate [(ngModel)]="filtreData.endDBc" (ngModelChange)="onChange($event)" name="DBc">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>

            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">date non valide</mat-error>
            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">date non valide</mat-error>
          </mat-form-field>
        </div>
      </div>
      <!-- date creation BC -->
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>Date de création du BC</mat-label>
            <mat-date-range-input [rangePicker]="picker2">
              <input matStartDate [(ngModel)]="filtreData.startDCreationBc" (ngModelChange)="onChange($event)" name="DCreationBc">
              <input matEndDate [(ngModel)]="filtreData.endDCreationBc" (ngModelChange)="onChange($event)" name="DCreationBc">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-date-range-picker #picker2></mat-date-range-picker>

            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">date non valide</mat-error>
            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">date non valide</mat-error>
          </mat-form-field>
        </div>
      </div>
      <!-- date fin de validité BC enveloppe -->
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>Date de fin de validité (commande enveloppe)</mat-label>
            <mat-date-range-input [rangePicker]="picker3">
              <input matStartDate [(ngModel)]="filtreData.startDValiditeBcEnv" (ngModelChange)="onChange($event)" name="dFinValid">
              <input matEndDate [(ngModel)]="filtreData.endDValiditeBcEnv" (ngModelChange)="onChange($event)" name="dFinValid">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-date-range-picker #picker3></mat-date-range-picker>

            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">date non valide</mat-error>
            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">date non valide</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-10 margin_bm_20">
          <app-autocomplete-with-code [(objet)]="filtreData.bcFourn" (objetChange)="onChange($event)"
            libelle="Fournisseur"  [required]="false" name="Fournisseur" 
            (loadData)="loadData($event, fournisseurService ,'fournisseurs')" 
            [objets]="fournisseurs">
          </app-autocomplete-with-code>
        </div>
        <div class="col-sm-1 margin_bm_20">
          <mat-icon style="margin-top: 10px;" type="submit" (click)="openModalFournisseur()" id="search">search</mat-icon>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>Libellé Fournisseur</mat-label>
            <input matInput [(ngModel)]="filtreData.libelleFourn" (ngModelChange)="onChange($event)" name=""
              style="font-size: small;" [ngModelOptions]="{standalone: true}" name="refFourn">
          </mat-form-field>
        </div>
      </div>
      
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>Réf Fournisseur</mat-label>
            <input matInput [(ngModel)]="filtreData.refFourn" (ngModelChange)="onChange($event)" name=""
              style="font-size: small;" [ngModelOptions]="{standalone: true}" name="refFourn">
          </mat-form-field>
        </div>
      </div>

      <!-- date LIVRAISON -->
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <mat-form-field class="full-width">
            <mat-label>Date de livraison</mat-label>
            <mat-date-range-input [rangePicker]="picker1">
              <input matStartDate [(ngModel)]="filtreData.startDLivBc" (ngModelChange)="onChange($event)" name="DLivBc">
              <input matEndDate [(ngModel)]="filtreData.endDLivBc" (ngModelChange)="onChange($event)" name="DLiveBc">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-date-range-picker #picker1></mat-date-range-picker>
            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">date non valide</mat-error>
            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">date non valide</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <app-autocomplete-user [(userId)]="filtreData.idCreateur" (updated)="onFiltreChange($event, 'Createur')" libelle="Créateur" 
          [users]="users" name="user">
          </app-autocomplete-user>
        </div>
      </div>
      
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <app-autocomplete-user [(userId)]="filtreData.idValidateur" (updated)="onFiltreChange($event, 'Valideur')" libelle="Valideur" 
          [users]="validors" name="user">
          </app-autocomplete-user>
        </div>
      </div>
      <!-- ca1 -->
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <app-autocomplete-with-code [(objet)]="filtreData.bcCa1" (objetChange)="onChange($event)" libelle="Ca1"
            [objets]="ca1s" name="Ca1" (loadData)="loadData($event, ca1Service ,'ca1s')">
          </app-autocomplete-with-code>
        </div>
      </div>
      <!-- ca2 -->
      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <app-autocomplete-with-code [(objet)]="filtreData.bcCa2" (objetChange)="onChange($event)" libelle="Ca2" 
          [objets]="ca2s" name="Ca2" (loadData)="loadData($event, ca2Service ,'ca2s')">
          </app-autocomplete-with-code>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 margin_bm_20">
          <app-autocomplete-with-code [(objet)]="filtreData.complement" (objetChange)="onChange($event)"
            libelle="Complément" [objets]="comps" name="Complement" (loadData)="loadData($event, compService ,'comps')">
          </app-autocomplete-with-code>
        </div>
      </div>
      

      <div class="row">
        <div class="col-sm-6 margin_bm_20">
          <app-autocomplete-with-code [(objet)]="filtreData.startNa" (objetChange)="onChange($event)" libelle="NA de" 
          [objets]="nasStart" name="NA" (loadData)="loadData($event, naService ,'nasStart')">
          </app-autocomplete-with-code>
        </div>
        <div class="col-sm-6 margin_bm_20">
          <app-autocomplete-with-code [(objet)]="filtreData.endNa" (objetChange)="onChange($event)" libelle="au" 
          [objets]="nasEnd" name="NA" (loadData)="loadData($event, naService , 'nasEnd')">
          </app-autocomplete-with-code>
        </div>
      </div>
    
      <div class="row">
        <div class="col-sm-6">
          <mat-form-field class="full-width">
            <mat-label>Code Chantier: de</mat-label>
            <input matInput [(ngModel)]="filtreData.startAe" (ngModelChange)="onChange($event)" name="CodeAe"
              style="font-size: small;" [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field class="full-width">
            <mat-label>à</mat-label>
            <input matInput [(ngModel)]="filtreData.endAe" (ngModelChange)="onChange($event)" name="CodeAe"
              style="font-size: small;" [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
      </div>


      <div class="row">
        <div class="col-sm-6">
          <app-custom-select-multiple-option 
            (selected)="onFiltreChange($event, 'BC bloqués')" [InputvaluesList]="flagList" 
            [InputSelectedValues]="bFlagList" [title]="'BC bloqués'">
          </app-custom-select-multiple-option>
        </div>
        <div class="col-sm-6">
          <app-custom-select-multiple-option 
            (selected)="onFiltreChange($event, 'BC facturés')" [InputvaluesList]="flagList" 
            [InputSelectedValues]="fFlagList" [title]="'BC facturés'">
          </app-custom-select-multiple-option>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <app-custom-select-multiple-option 
            (selected)="onFiltreChange($event, 'BC livrés')" [InputvaluesList]="flagList" 
            [InputSelectedValues]="lFlagList" [title]="'BC livrés'">
          </app-custom-select-multiple-option>
        </div>
        <div class="col-sm-6">
          <app-custom-select-multiple-option 
            (selected)="onFiltreChange($event, 'BC déprovisionnés')" [InputvaluesList]="flagList" 
            [InputSelectedValues]="dFlagList" [title]="'BC déprovisionnés'">
          </app-custom-select-multiple-option>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <app-custom-select-multiple-option 
            (selected)="onFiltreChange($event, 'BC validés')" [InputvaluesList]="flagList" 
            [InputSelectedValues]="vFlagList" [title]="'BC validés'">
          </app-custom-select-multiple-option>
        </div>

        <div class="col-sm-6">
          <app-custom-select-multiple-option 
            (selected)="onFiltreChange($event, 'BC annulés')" [InputvaluesList]="flagList" 
            [InputSelectedValues]="aFlagList" [title]="'BC annulés'">
          </app-custom-select-multiple-option>
        </div>
      </div>


      <div class="row">
        <div class="col-sm-6">
          <app-custom-select-multiple-option 
            (selected)="onFiltreChange($event, 'BC provisionnés')" [InputvaluesList]="flagList" 
            [InputSelectedValues]="pFlagList" [title]="'BC provisionnés'">
          </app-custom-select-multiple-option>
        </div>
      </div>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <div>
      <div class="row">
        <div class="col-sm-8 margin_bm_20">
          <h3> {{title}} </h3>
        </div>
        <div *ngIf="isCreateBp" class="col-sm-2" style="display: flex; justify-content: flex-end;">
          <button color="success" mat-raised-button type="button" (click)="goToCreateBP()" [disabled]="bp === null">
            <mat-icon>check</mat-icon>Créer un BP
          </button>
        </div>
        <div *ngIf="isListAValide" class="col-sm-2" style="display: flex; justify-content: flex-end;">
          <button color="success" mat-raised-button type="button" (click)="onValidationBcs()" [disabled]="selectedBcsChild.length === 0">
            <mat-icon>check</mat-icon>Valider des BCs
          </button>
        </div>
      </div>
      <div class="col-sm-12">
        <mat-card>
          <mat-card-header>
            <mat-card-title>Résultats :
            </mat-card-title>
            <span class="filter-button">
              <mat-card-title>
                <button color="success" mat-raised-button type="button" (click)="onExport()">
                  <mat-icon>import_export</mat-icon>Export
                </button>
                <button color="primary" (click)="sideNav.toggle(); load();" mat-stroked-button>
                  <mat-icon color="primary" id="icon">filter_list</mat-icon>filtres
                </button>
              </mat-card-title>
            </span>
          </mat-card-header>
          <mat-card-content>
            <app-bc-list [datasource]="bcList" [ifCreateBp]="isCreateBp" [ifListAValide]="isListAValide" 
            (selectedRowsEmit)="getSelectedBcs($event)" [(filtreData)]="filtreData" [simpleQueryBcResponse]="simpleQueryBcResponse" >
            </app-bc-list>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

  </mat-drawer-content>
</mat-drawer-container>